import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dc6a776"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header w-100 pt-10" }
const _hoisted_3 = { class: "row w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 col-md-6 col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Personal Details")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "col-12 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex justify-content-end"
}
const _hoisted_6 = {
  key: 0,
  class: "card-body p-9"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Full Name", -1))
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "fw-bold fs-6" }
const _hoisted_13 = { class: "row mb-7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Mobile Number ", -1))
const _hoisted_15 = { class: "col-lg-8 d-flex justify-content-start align-items-center" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "text-danger",
  "data-bs-toggle": "modal",
  "data-bs-target": "#link_mobile_form_modal"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-times-circle text-danger ms-2 me-2",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Verify mobile number?", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "text-success"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle text-success ms-2 me-2",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Verified", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Date of birth", -1))
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fw-bold fs-6" }
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Email", -1))
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = { class: "fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = { class: "row mb-7" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Address Line", -1))
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "fw-bold fs-6" }
const _hoisted_38 = { class: "row mb-7" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "City", -1))
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "fw-bold fs-6" }
const _hoisted_42 = { class: "row mb-7" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "State", -1))
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fw-bold fs-6" }
const _hoisted_46 = { class: "row mb-7" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Postal Code", -1))
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = { class: "fw-bold fs-6" }
const _hoisted_50 = { class: "row mb-7" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Country", -1))
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "fw-bold fs-6" }
const _hoisted_54 = {
  key: 1,
  class: "column container py-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkMobile = _resolveComponent("LinkMobile")!
  const _component_ProfileForm = _resolveComponent("ProfileForm")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEdit = !_ctx.isEdit)),
                class: "btn align-self-center btn-new-design-primary w-100 w-md-40 w-sm-100 w-lg-30 mt-3 mt-lg-0 mt-md-0 mt-sm-3"
              }, " Edit Profile ")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.authUser.first_name
                    ? _ctx.$filters.capitalize(_ctx.authUser.first_name)
                    : '') + " " + _toDisplayString(_ctx.authUser.last_name
                    ? _ctx.$filters.capitalize(_ctx.authUser.last_name)
                    : ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control text-truncate bg-none border-0 p-0 m-0 cursor-pointer mobile",
                    readonly: "",
                    style: {"width":"115px"},
                    value: _ctx.authUser.mobile_number
                  }, null, 8, _hoisted_16), [
                    [_directive_mask, _ctx.mobileMasking]
                  ]),
                  (_ctx.authUser.mobile_number)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.authUser.mobile_verified_at)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args))),
                                class: "text-danger"
                              }, _hoisted_20)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_24))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.authUser.date_of_birth
                    ? _ctx.formatDate(_ctx.authUser.date_of_birth, 'DD/MM/YYYY')
                    : ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString((_ctx.authUser || {}).email), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString((_ctx.authUser || {}).address_line), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString((_ctx.authUser || {}).city), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.stateName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString((_ctx.authUser || {}).post_code), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.countryName), 1)
                ])
              ])
            ])
          ]),
          _createVNode(_component_LinkMobile, {
            loading: _ctx.loading,
            onVerifyMobile: _ctx.handleVerify,
            ref: "verificationForm",
            successMessage: _ctx.sendCodeMessage
          }, null, 8, ["loading", "onVerifyMobile", "successMessage"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createVNode(_component_ProfileForm, {
            profile: _ctx.authUser,
            onEditMode: _ctx.handleEdit,
            onFormSubmmitted: _ctx.handleFormSubmitted
          }, null, 8, ["profile", "onEditMode", "onFormSubmmitted"])
        ]))
  ]))
}